var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.5C5 10.625 10.625 5 17.5 5C24.375 5 30 10.625 30 17.5C30 24.375 24.375 30 17.5 30C10.625 30 5 24.375 5 17.5Z",
    fill: "#32373A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.8125C18.021 11.8125 18.5206 12.0265 18.889 12.4074C19.2573 12.7884 19.4643 13.305 19.4643 13.8438V14.25H15.5357V13.8438C15.5357 13.305 15.7427 12.7884 16.111 12.4074C16.4794 12.0265 16.979 11.8125 17.5 11.8125ZM20.25 14.25V13.8438C20.25 13.0895 19.9603 12.3662 19.4445 11.8329C18.9288 11.2996 18.2293 11 17.5 11C16.7707 11 16.0712 11.2996 15.5555 11.8329C15.0397 12.3662 14.75 13.0895 14.75 13.8438V14.25H12V22.375C12 22.806 12.1656 23.2193 12.4603 23.524C12.755 23.8288 13.1547 24 13.5714 24H21.4286C21.8453 24 22.245 23.8288 22.5397 23.524C22.8344 23.2193 23 22.806 23 22.375V14.25H20.25Z",
    fill: "#E1D9CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.c40e3cd38d8148ee6034b414e64367c2.svg";
export { ForwardRef as ReactComponent };